var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAdder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 61,
    viewBox: "0 0 56 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 40.5,
    r: 20.5,
    fill: "#E3B505"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 13,
    r: 10,
    fill: "#5B7582"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3334 11.6667V0.766667C35.85 1.35 37.25 2.23333 38.4334 3.41667L44.2334 9.23333C45.4167 10.4167 46.3 11.8167 46.8834 13.3333H35.9834C35.0667 13.3333 34.3167 12.5833 34.3167 11.6667H34.3334ZM47.6667 17.4833V31.6667C47.6667 36.2667 43.9334 40 39.3334 40H22.6667C18.0667 40 14.3334 36.2667 14.3334 31.6667V8.33333C14.3334 3.73333 18.0667 0 22.6667 0H30.1834C30.45 0 30.7167 0.0166667 31 0.0333333V11.6667C31 14.4167 33.25 16.6667 36 16.6667H47.6334C47.65 16.9333 47.6667 17.2 47.6667 17.4833ZM33.1667 28.3333L36.45 24.4C37.0334 23.7 36.95 22.65 36.2334 22.05C35.5167 21.4667 34.4834 21.55 33.8834 22.2667L31 25.7333L28.1167 22.2667C27.5334 21.5667 26.4834 21.4667 25.7667 22.05C25.0667 22.6333 24.9667 23.6833 25.55 24.4L28.8334 28.3333L25.55 32.2667C24.9667 32.9667 25.05 34.0167 25.7667 34.6167C26.0834 34.8833 26.45 35 26.8334 35C27.3167 35 27.7834 34.8 28.1167 34.4L31 30.9333L33.8834 34.4C34.2167 34.8 34.6834 35 35.1667 35C35.55 35 35.9167 34.8667 36.2334 34.6167C36.9334 34.0333 37.0334 32.9833 36.45 32.2667L33.1667 28.3333Z",
    fill: "#131CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdder);
export default __webpack_public_path__ + "static/media/FileAdder.eabcc02caf8ca934b0bbfaef88a02c00.svg";
export { ForwardRef as ReactComponent };